import {Cookies} from 'react-cookie';
import APIService from '../../services/api'
import {handleError} from '../infos/actions'
import {
    TRAIL_DELETED,
    TRAIL_DELETING,
    TRAIL_DOWNLOADED,
    TRAIL_EDITING,
    TRAIL_FAILED,
    TRAIL_FOCUS,
    TRAIL_MEDIA_DELETED,
    TRAIL_MEDIA_DELETING,
    TRAIL_MEDIA_FAILED,
    TRAIL_MEDIA_FOCUS,
    TRAIL_MEDIA_UPLOADED,
    TRAIL_MEDIA_UPLOADING,
    TRAIL_POSTING,
    TRAIL_RESET,
    TRAILS_DOWNLOADED,
    TRAILS_FAILED,
    TRAILS_PENDING,
    TRAILS_RESET
} from "./types";

const cookies = new Cookies();

// Action creators

export const trailsResetAction = () => {
    return {
        type: TRAILS_RESET
    }
};

export const trailResetAction = () => {
    return {
        type: TRAIL_RESET
    }
};

export const trailsPendingAction = () => {
    return {
        type: TRAILS_PENDING
    }
};

export const postTrailAction = () => {
    return {
        type: TRAIL_POSTING
    }
};

export const trailEditingAction = () => {
    return {
        type: TRAIL_EDITING
    }
};

export const trailDownloadedAction = (trail, lang) => {
    return {
        type: TRAIL_DOWNLOADED,
        payload: {lang: lang, trail: trail}
    };
};


export const trailsDownloadedAction = (trails, lang) => {
    return {
        type: TRAILS_DOWNLOADED,
        payload: {lang: lang, trails: trails}
    }
};

export const trailFocusAction = (trail, lang) => {
    return {
        type: TRAIL_FOCUS,
        payload: {trail: trail, lang: lang}
    };
};

export const deleteTrailAction = () => {
    return {
        type: TRAIL_DELETING
    };
};

export const trailDeletedAction = (id, lang) => {
    return {
        type: TRAIL_DELETED,
        payload: {id: id, lang: lang}
    };
};

export const trailMediaFocusAction = (media) => {
    return {
        type: TRAIL_MEDIA_FOCUS,
        payload: media
    }
};

export const uploadMediaAction = (media) => {
    return {
        type: TRAIL_MEDIA_UPLOADING,
        payload: media
    };
};

export const uploadMediaSucceedAction = (media) => {
    return {
        type: TRAIL_MEDIA_UPLOADED,
        payload: media
    };
};

export const uploadMediaFailedAction = (media) => {
    return {
        type: TRAIL_MEDIA_FAILED,
        payload: media
    };
};

export const deleteMediaAction = () => {
    return {
        type: TRAIL_MEDIA_DELETING
    };
};

export const trailMediaDeletedAction = (mediaId) => {
    return {
        type: TRAIL_MEDIA_DELETED,
        payload: mediaId
    };
};

// Actions

export function resetTrails() {
    return function (dispatch) {
        dispatch(trailsResetAction());
    }
}

export function resetTrail() {
    return function (dispatch) {
        dispatch(trailResetAction());
    }
}

export function getTrails(app, lang) {
    return function (dispatch) {
        dispatch(trailsPendingAction());
        return APIService
            .getTrails(app, cookies.get('token'), lang)
            .then(trails => {
                dispatch(trailsDownloadedAction(trails, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAILS_FAILED))
            });
    }
}

export function fetchTrail(appId, trailId, lang) {
    return function (dispatch, getState) {
        let trails = getState().trails.content[lang];
        if (trails !== undefined) {
            let trail = trails.find(function (trail) {
                return trail.id === trailId
            });
            if (trail) {
                return dispatch(trailFocusAction(trail, lang));
            }
        }
        return dispatch(getTrail(appId, trailId, lang));
    }
}

export function getTrail(appId, trailId, lang) {
    return function (dispatch) {
        dispatch(trailsPendingAction());
        return APIService
            .getTrail(appId, trailId, cookies.get('token'), lang)
            .then(trail => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function deleteTrail(appId, trailId, lang) {
    return function (dispatch) {
        dispatch(deleteTrailAction());
        return APIService
            .deleteTrail(appId, trailId, cookies.get('token'), lang)
            .then(() => {
                dispatch(trailDeletedAction(trailId, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function putTrail(appId, trail, lang) {
    return function (dispatch) {
        dispatch(trailEditingAction());
        return APIService
            .putTrail(appId, trail, cookies.get('token'), lang)
            .then(trail => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function postTrail(appId, trail, lang) {
    return function (dispatch) {
        dispatch(postTrailAction());
        return APIService
            .postTrail(appId, trail, cookies.get('token'), lang)
            .then(trail => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function postTrailGpx(appId, trailId, file, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(trailEditingAction());
        return APIService
            .postTrailGpx(appId, trailId, file, cookies.get('token'), lang, onUploadProgress)
            .then((trail) => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function postTrailKml(appId, trailId, file, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(trailEditingAction());
        return APIService
            .postTrailKml(appId, trailId, file, cookies.get('token'), lang, onUploadProgress)
            .then((trail) => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function postTrailGeojson(appId, trailId, file, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(trailEditingAction());
        return APIService
            .postTrailGeojson(appId, trailId, file, cookies.get('token'), lang, onUploadProgress)
            .then((trail) => {
                dispatch(trailDownloadedAction(trail, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

// MEDIA

export function fetchTrailMedia(appId, trailId, mediaId, lang) {
    return function (dispatch, getState) {
        return dispatch(getTrailMedia(appId, trailId, mediaId, lang));
    }
}

export function getTrailMedia(appId, trailId, mediaId, lang) {
    return function (dispatch) {
        dispatch(trailsPendingAction());
        return APIService
            .getTrailMedia(appId, trailId, mediaId, cookies.get('token'), lang)
            .then(media => {
                dispatch(trailMediaFocusAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAILS_FAILED))
            });
    }
}

export function deleteTrailMedia(appId, trailId, media, lang) {
    return function (dispatch) {
        dispatch(deleteMediaAction());
        return APIService
            .deleteTrailMedia(appId, trailId, media, cookies.get('token'), lang)
            .then(() => {
                dispatch(trailMediaDeletedAction(media.id));
            })
            .catch((error) => {
                dispatch(handleError(error, TRAIL_FAILED))
            });
    }
}

export function postTrailMedia(appId, trailId, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        if (typeof media === 'string') {
            return APIService
                .postTrailLinkMedia(appId, trailId, media, cookies.get('token'), lang)
                .then(trail => {
                    dispatch(trailDownloadedAction(trail, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        } else {
            return APIService
                .postTrailMedia(appId, trailId, media, cookies.get('token'), lang, onUploadProgress)
                .then(trail => {
                    dispatch(trailDownloadedAction(trail, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        }
    }
}


export function putTrailMedia(appId, trailId, media, lang) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        return APIService
            .putTrailMedia(appId, trailId, media, cookies.get('token'), lang)
            .then(trail => {
                dispatch(trailDownloadedAction(trail, lang));
                dispatch(uploadMediaSucceedAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error));
                dispatch(uploadMediaFailedAction(media));
            });
    }
}




// WEBPACK FOOTER //
// src/store/trails/actions.js